import React from 'react';
import BaseCell from './BaseCell';

const TextCell = ({ children, dataItem, field, maxLength = 250, ...props }) => {
  if (children) {
    return <BaseCell {...props}>{children}</BaseCell>;
  }

  const displayValue = dataItem[field] && typeof dataItem[field] === 'string' && dataItem[field] !== '' && dataItem[field].length > maxLength
    ? `${dataItem[field].slice(0, maxLength)} …` : dataItem[field] ?? '';

  return <BaseCell title={dataItem[field]} {...props}>{displayValue}</BaseCell>;
};

export default TextCell;
